const REMOVE_ICON_SVG =
  '<svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.918 6.45312V19.8821C13.918 20.9341 13.058 21.7941 12.0059 21.7941H3.33331C2.28129 21.7941 1.42126 20.9341 1.42126 19.8821V6.45312H13.918ZM10.5356 9.22475C10.5356 9.00609 10.7121 8.82936 10.9273 8.82936C11.1424 8.82936 11.3227 9.00609 11.3227 9.22475V18.2428C11.3227 18.4576 11.1462 18.6344 10.9273 18.6344C10.7083 18.6344 10.5356 18.4576 10.5356 18.2428V9.22475ZM7.27611 9.22475C7.27611 9.00609 7.45257 8.82936 7.66772 8.82936C7.88287 8.82936 8.06316 9.00609 8.06316 9.22475V18.2428C8.06316 18.4576 7.88639 18.6344 7.66772 18.6344C7.44905 18.6344 7.27611 18.4576 7.27611 18.2428V9.22475ZM4.01658 9.22475C4.01658 9.00609 4.19333 8.82936 4.412 8.82936C4.63067 8.82936 4.80361 9.00609 4.80361 9.22475V18.2428C4.80361 18.4576 4.62715 18.6344 4.412 18.6344C4.19685 18.6344 4.01658 18.4576 4.01658 18.2428V9.22475Z" fill="black"></path><path d="M13.5496 2.82889H10.6087V2.34146C10.6087 1.94224 10.5204 1.5697 10.3478 1.29741C10.1558 0.986419 9.86766 0.794434 9.49921 0.794434H5.84425C5.47199 0.794434 5.18385 0.986419 4.99185 1.29741C4.8192 1.57 4.73068 1.94224 4.73068 2.34146V2.82889H1.78977C0.898969 2.82889 0.169678 3.55463 0.169678 4.44509V5.6697H15.1697V4.44509C15.1697 3.55434 14.4401 2.82889 13.5496 2.82889ZM5.5139 2.34146C5.5139 2.08411 5.56373 1.85783 5.65607 1.70805C5.7059 1.62745 5.77126 1.57762 5.84425 1.57762H9.49921C9.56838 1.57762 9.63346 1.62745 9.68358 1.70805C9.77562 1.85783 9.82575 2.0844 9.82575 2.34146V2.82889H5.51419L5.5139 2.34146Z" fill="black"></path></svg>';

const EMPTY_BLOCK_SVG =
  '<svg width="173" height="200" viewBox="0 0 173 200" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="1.25" y="1.25" width="170.482" height="197.347" fill="white" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-dasharray="13 13"></rect></svg>';

customElements.whenDefined("modal-dialog").then(() => {
  class BundleBuilderPopup extends customElements.get("modal-dialog") {
    constructor() {
      super();
      this.cartThresholdCents = Number(this.dataset.cartThreshold || 0);
      this.excludedProductIds = this.parseExcludedProductIds();
      this.maxProducts = Number(this.dataset.maxProducts || 0);
      this.moneyFormat = this.dataset.moneyFormat || "";
      this.sectionId = this.dataset.sectionId || "";
      this.discountTiers = this.parseDiscountTiers();
      this.hasSaleItem = false;
      this.selectedProducts = {};
      this.lastSavingsAmount = undefined;
      this.displayedSavingsAmount = 0;
      this.savingsAnimationFrame = null;
      this.boundHandleCartUpdate = this.handleCartUpdate.bind(this);
      this.boundSectionSelect = this.onSectionSelect.bind(this);
      this.boundSectionDeselect = this.onSectionDeselect.bind(this);
      this.boundSectionUnload = this.onSectionUnload.bind(this);
      this.boundCheckSidebarVisibility = this.checkSidebarVisibility.bind(this);
    }

    selector(name) {
      return `.${name}-${this.sectionId}`;
    }

    connectedCallback() {
      super.connectedCallback();
      if (this.initialized) return;
      this.initialized = true;
      this.cacheElements();
      this.initBundle();
      this.subscribeToCartUpdates();
      this.bindThemeEditorEvents();
    }

    disconnectedCallback() {
      if (typeof this.unsubscribeCartUpdate === "function") {
        this.unsubscribeCartUpdate();
      }
      document.removeEventListener("shopify:section:select", this.boundSectionSelect);
      document.removeEventListener("shopify:section:deselect", this.boundSectionDeselect);
      document.removeEventListener("shopify:section:unload", this.boundSectionUnload);
      if (this.boundResizeSidebar) {
        window.removeEventListener("resize", this.boundResizeSidebar);
      }
      if (this.boundScrollSidebar) {
        const scrollRoot = this.bundlePopupInner || window;
        scrollRoot.removeEventListener("scroll", this.boundScrollSidebar);
      }
      this.cancelSavingsAnimation();
      clearTimeout(this.suppressAutoOpenTimer);
    }

    cacheElements() {
      this.mainButtons = this.querySelectorAll(this.selector("bundle-submit-button"));
      this.mainButton = this.mainButtons[0] || null;
      this.products = this.querySelectorAll(this.selector("bundle-product"));
      this.bundleSidebarProductsContainer = this.querySelector(this.selector("bundle-sidebar-products"));
      this.savingsCalloutMessageValues = this.querySelectorAll(this.selector("bundle-savings-callout-message-value"));
      this.savingsCalloutEyebrows = this.querySelectorAll(this.selector("bundle-savings-callout-eyebrow"));
      this.savingsCalloutValues = this.querySelectorAll(this.selector("bundle-savings-callout-value"));
      this.savingsCalloutStepsList = this.querySelectorAll(this.selector("bundle-savings-callout-steps"));
      this.savingsCalloutStepItems = this.querySelectorAll(this.selector("bundle-savings-callout-step"));
      this.savingsCalloutMessageValue = this.savingsCalloutMessageValues[0] || null;
      this.savingsCalloutEyebrow = this.savingsCalloutEyebrows[0] || null;
      this.savingsCalloutValue = this.savingsCalloutValues[0] || null;
      this.savingsCalloutSteps = this.savingsCalloutStepsList[0] || null;
      this.discountLevels = this.querySelectorAll('[data-discount-level]');
      this.sidebarHeading = this.querySelector(this.selector("bundle-sidebar-heading"));
      this.sidebarSubheading = this.querySelector(this.selector("bundle-sidebar-subheading"));
      this.originalHeadingHTML = this.sidebarHeading ? this.sidebarHeading.innerHTML : "";
      this.originalSubheadingHTML = this.sidebarSubheading ? this.sidebarSubheading.innerHTML : "";
      this.stickyButton = this.querySelector(`#bundle-sticky-button-${this.sectionId}`);
      this.stickyScrollButton = this.querySelector(`#bundle-sticky-scroll-${this.sectionId}`);
      this.sidebarWrapper = this.querySelector(`${this.selector("bundle-sidebar-wrapper")}${this.selector("bundle-layout-mobile")}`);
      this.bundlePopupInner = this.querySelector(this.selector("bundle-builder-popup-scroll"))
        || this.querySelector(this.selector("bundle-builder-popup-dialog"));
      this.forms = this.querySelectorAll(this.selector("bundle-form"));
      this.form = this.forms[0] || null;
      const productSource = this.querySelector(this.selector("bundle-products-source"));
      this.renderedCatalogKey = productSource?.dataset.catalogKey || "";
    }

    qualifiesForGifts(cart) {
      const source = cart || window.cartData;
      if (this.cartHasSaleItem(source)) return false;
      if (!this.cartThresholdCents) return true;
      if (!source || typeof source.total_price !== "number") return false;
      return this.getEligibleCartTotal(source) >= this.cartThresholdCents;
    }

    show(opener) {
      const preview = window.Shopify && Shopify.designMode;
      const focusTarget = opener && typeof opener.focus === "function" ? opener : null;
      const fromCheckout = Boolean(opener && opener.source === "checkout");
      if (!preview && this.suppressAutoOpen && !fromCheckout) return;
      if (!preview && (this.hasSaleItem || !this.qualifiesForGifts())) return;
      if (this.hasAttribute("open")) return;
      if (fromCheckout) {
        this.suppressAutoOpen = false;
        clearTimeout(this.suppressAutoOpenTimer);
      }
      this.openedFromCheckout = fromCheckout;
      this.openedBy = focusTarget;
      this.scrollLockTarget = this.bundlePopupInner || this.dialogHolder;
      bodyScroll.lock(this.scrollLockTarget);
      this.setAttribute("open", "");
      trapFocus(this, this.dialogHolder);
      this.checkSidebarVisibility();
    }

    hide() {
      if (!this.hasAttribute("open")) return;
      bodyScroll.unlock(this.scrollLockTarget || this.bundlePopupInner || this.dialogHolder);
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
      if (!document.querySelector("cart-drawer.is-visible")) {
        document.body.style.overflow = "";
      }
      this.removeAttribute("open");
      removeTrapFocus(this.openedBy && typeof this.openedBy.focus === "function" ? this.openedBy : null);
      if (this.openedFromCheckout) {
        setCookie("bundle_popup_checkout_dismissed", "true");
        this.openedFromCheckout = false;
      }
      this.checkSidebarVisibility();
      this.suppressAutoOpen = true;
      clearTimeout(this.suppressAutoOpenTimer);
      this.suppressAutoOpenTimer = setTimeout(() => {
        this.suppressAutoOpen = false;
      }, 2000);
    }

    subscribeToCartUpdates() {
      const subscribeFn = window.subscribe || (typeof subscribe === "function" ? subscribe : null);
      const eventName =
        (typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.cartUpdate) ||
        "cart-update";

      if (typeof subscribeFn === "function") {
        this.unsubscribeCartUpdate = subscribeFn(eventName, this.boundHandleCartUpdate);
      }

      this.handleCartUpdate({ skipOpen: true });
    }

    bindThemeEditorEvents() {
      document.addEventListener("shopify:section:select", this.boundSectionSelect);
      document.addEventListener("shopify:section:deselect", this.boundSectionDeselect);
      document.addEventListener("shopify:section:unload", this.boundSectionUnload);
    }

    onSectionSelect(event) {
      if (event.detail.sectionId === this.sectionId) this.show();
    }

    onSectionDeselect(event) {
      if (event.detail.sectionId === this.sectionId) this.hide();
    }

    onSectionUnload(event) {
      if (event.detail.sectionId === this.sectionId) this.remove();
    }

    getCartFromEvent(data) {
      if (!data) return null;
      return data.cartData || data.cart || null;
    }

    isFullCart(cart) {
      return Boolean(cart && Array.isArray(cart.items) && typeof cart.total_price === "number");
    }

    async getCart(data) {
      const eventCart = this.getCartFromEvent(data);
      if (this.isFullCart(eventCart)) return eventCart;

      try {
        const response = await fetch("/cart.js");
        if (!response.ok) return null;
        return await response.json();
      } catch (error) {
        return null;
      }
    }

    parseExcludedProductIds() {
      try {
        const ids = JSON.parse(this.dataset.excludedProducts || "[]");
        return new Set(
          (Array.isArray(ids) ? ids : []).map((id) => Number(id)).filter(Boolean)
        );
      } catch (error) {
        return new Set();
      }
    }

    isSaleItem(item) {
      const sale = item && item.properties && item.properties._sale;
      return sale === true || sale === "true";
    }

    isExcludedFromThreshold(item) {
      if (!item) return false;
      return this.excludedProductIds.has(Number(item.product_id));
    }

    cartHasSaleItem(cart) {
      if (!cart) return false;
      const items = Array.isArray(cart.items) ? cart.items : [cart];
      return items.some((item) => this.isSaleItem(item));
    }

    getCatalogKey(cart) {
      const items = Array.isArray(cart && cart.items) ? cart.items : [];
      return items
        .filter((item) => {
          if (this.isSaleItem(item)) return false;
          const itemType = String((item.properties && item.properties._item_type) || "");
          return !itemType.includes("subitem");
        })
        .map((item) => String(item.product_id))
        .join(",");
    }

    resetSelection() {
      this.selectedProducts = {};
      this.querySelectorAll(this.selector("bundle-product")).forEach((product) => {
        product.classList.remove("active", "product-disabled");
      });
      this.updateSidebarProducts();
    }

    async syncProductsWithCart(cart) {
      if (!cart || !this.sectionId) return;

      const catalogKey = this.getCatalogKey(cart);
      if (catalogKey === this.renderedCatalogKey) return;

      const requestId = (this.productSyncRequestId || 0) + 1;
      this.productSyncRequestId = requestId;

      try {
        const response = await fetch(
          `${window.location.pathname}?section_id=${encodeURIComponent(this.sectionId)}`
        );
        if (!response.ok || requestId !== this.productSyncRequestId) return;

        const text = await response.text();
        let html = text;
        if (text.trim().startsWith("{")) {
          const parsed = JSON.parse(text);
          html = parsed[this.sectionId] || "";
        }
        if (!html || requestId !== this.productSyncRequestId) return;

        const doc = new DOMParser().parseFromString(html, "text/html");
        const next = doc.querySelector(this.selector("bundle-products-source"));
        const current = this.querySelector(this.selector("bundle-products-source"));
        if (!next || !current || requestId !== this.productSyncRequestId) return;

        if (next.innerHTML === current.innerHTML) {
          current.dataset.catalogKey = catalogKey;
          this.renderedCatalogKey = catalogKey;
          return;
        }

        current.replaceWith(next);
        this.renderedCatalogKey = catalogKey;
        this.products = this.querySelectorAll(this.selector("bundle-product"));
        this.resetSelection();
        this.bindProductClicks();
        this.bindCollectionAccordionPeek();
      } catch (error) {
        // Keep the current grid if the refresh fails.
      }
    }

    getEligibleCartTotal(cart) {
      if (!cart || typeof cart.total_price !== "number") return 0;
      const items = Array.isArray(cart.items) ? cart.items : [];
      const excludedTotal = items.reduce((sum, item) => {
        if (!this.isSaleItem(item) && !this.isExcludedFromThreshold(item)) return sum;
        return sum + (Number(item.final_line_price) || 0);
      }, 0);
      return Math.max(0, cart.total_price - excludedTotal);
    }

    showRemovalBanner() {
      const amount = this.formatMoney(this.cartThresholdCents, this.moneyFormat);
      const message = amount
        ? `Your free products were removed because your cart is below the ${amount} threshold.`
        : "Your free products were removed because your cart doesn't meet the threshold.";

      const drawer = document.querySelector("cart-drawer.is-visible .cart-drawer__inner");
      let banner = document.querySelector(".bundle-removal-banner");

      if (!banner) {
        banner = document.createElement("div");
        banner.className = "bundle-removal-banner";
        banner.setAttribute("role", "status");
      }

      if (drawer) {
        banner.classList.remove("bundle-removal-banner--page");
        const head = drawer.querySelector(".cart-drawer__head");
        if (banner.parentElement !== drawer) {
          if (head) head.insertAdjacentElement("afterend", banner);
          else drawer.prepend(banner);
        }
      } else if (banner.parentElement !== document.body) {
        banner.classList.add("bundle-removal-banner--page");
        document.body.appendChild(banner);
      }

      banner.innerHTML = message;
      banner.classList.remove("is-visible");
      requestAnimationFrame(() => {
        banner.classList.add("is-visible");
      });

      clearTimeout(this.removalBannerTimer);
      this.removalBannerTimer = setTimeout(() => {
        banner.classList.remove("is-visible");
      }, 6000);
    }

    async removeSaleItems(cart) {
      if (this.isRemovingSaleItems) return;

      const items = Array.isArray(cart && cart.items) ? cart.items : [];
      const updates = {};
      items.forEach((item) => {
        if (!this.isSaleItem(item) || !item.key) return;
        updates[item.key] = 0;
      });

      if (!Object.keys(updates).length) return;

      this.isRemovingSaleItems = true;

      try {
        const response = await fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          body: JSON.stringify({
            updates,
            sections: (document.querySelector("cart-drawer")?.getSectionsToRender() || []).map(section => section.section),
            sections_url: window.location.pathname,
          }),
        });

        if (!response.ok) return;

        const updatedCart = await response.json();
        window.cartData = updatedCart;
        this.hasSaleItem = this.cartHasSaleItem(updatedCart);

        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.renderContents(updatedCart, false);
        }

        this.showRemovalBanner();
      } catch (error) {
        // Ignore — cart state will refresh on the next update.
      } finally {
        this.isRemovingSaleItems = false;
      }
    }

    async handleCartUpdate(data) {
      const skipOpen = Boolean(data && data.skipOpen);
      if (this.isRemovingSaleItems) return;

      const cart = await this.getCart(data);
      if (cart) window.cartData = cart;

      this.hasSaleItem = this.cartHasSaleItem(cart);

      await this.syncProductsWithCart(cart);

      if (!this.cartThresholdCents) {
        if (this.hasSaleItem) this.hide();
        return;
      }

      const total = this.getEligibleCartTotal(cart);

      if (total < this.cartThresholdCents) {
        this.hide();
        if (this.hasSaleItem) {
          await this.removeSaleItems(cart);
        }
        return;
      }

      if (this.hasSaleItem) {
        this.hide();
        return;
      }

      if (!skipOpen) this.show();
    }

    formatMoney(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }

      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || (typeof Shopify !== "undefined" && Shopify.money_format);

      if (typeof formatString !== "string") {
        return "";
      }

      function defaultOption(opt, def) {
        return typeof opt === "undefined" ? def : opt;
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ",");
        decimal = defaultOption(decimal, ".");

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split(".");
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
        const formattedCents = parts[1] ? decimal + parts[1] : "";

        return dollars + formattedCents;
      }

      const matchResult = formatString.match(placeholderRegex);
      if (!matchResult || !matchResult[1]) {
        return formatWithDelimiters(cents, 2);
      }

      switch (matchResult[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return formatString.replace(placeholderRegex, value);
    }

    initBundle() {
      this.bindStickySidebar();
      this.bindProductClicks();
      this.bindFormSubmit();
      this.bindCollectionAccordionPeek();
      this.updateSavingsCallout(0, 0);
      this.updateTotalAndButton();
    }

    syncCollectionAccordionState() {
      const accordion = this.querySelector(this.selector("bundle-collection-accordion"));
      if (!accordion) return;

      accordion.querySelectorAll("details.accordion__section").forEach((details) => {
        details.setAttribute("open", "");
        const isActive = details.classList.contains("is-active");
        const body = details.querySelector(":scope > .accordion__body");
        const summary = details.querySelector(":scope > summary");

        if (body) {
          body.classList.remove("is-transitioning");
          body.style.height = isActive ? "auto" : "";
        }

        summary?.setAttribute("aria-expanded", isActive ? "true" : "false");
      });
    }

    bindCollectionAccordionPeek() {
      const accordion = this.querySelector(this.selector("bundle-collection-accordion"));
      if (!accordion) return;

      this.syncCollectionAccordionState();
      accordion.addEventListener(
        "click",
        (event) => {
          const summary = event.target.closest("summary.js-btn");
          if (!summary || !accordion.contains(summary)) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          summary.closest("details")?.classList.toggle("is-active");
          this.syncCollectionAccordionState();
        },
        true
      );
    }

    bindFormSubmit() {
      if (!this.forms?.length) return;
      this.boundOnFormSubmit = this.onFormSubmit.bind(this);
      this.forms.forEach((form) => {
        form.addEventListener("submit", this.boundOnFormSubmit, true);
      });
    }

    onFormSubmit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      const form = event.currentTarget;
      const button = form.querySelector(this.selector("bundle-submit-button"));
      if (
        !button ||
        button.disabled ||
        button.getAttribute("aria-disabled") === "true" ||
        button.classList.contains("loading") ||
        !this.qualifiesForGifts()
      ) {
        if (!this.qualifiesForGifts()) this.hide();
        return;
      }

      this.submitBundle(form, button);
    }

    handleBundleError(form, errorMessage) {
      const errorWrapper = form.querySelector(".product-form__error-message-wrapper");
      const errorEl = form.querySelector(".product-form__error-message");
      if (!errorWrapper || !errorEl) return;

      errorWrapper.hidden = !errorMessage;
      if (errorMessage) errorEl.textContent = errorMessage;
    }

    setBundleLoading(button, isLoading) {
      const spinner = button.querySelector(".loading__spinner");
      button.classList.toggle("loading", isLoading);
      if (isLoading) {
        button.setAttribute("aria-disabled", "true");
        spinner?.classList.remove("hidden");
      } else {
        button.removeAttribute("aria-disabled");
        spinner?.classList.add("hidden");
      }
    }

    async submitBundle(form, button) {
      this.handleBundleError(form, false);
      this.setBundleLoading(button, true);

      const cart =
        document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formData = new FormData(form);
      if (cart && typeof cart.getSectionsToRender === "function") {
        formData.append(
          "sections",
          cart.getSectionsToRender().map((section) => section.section)
        );
        formData.append("sections_url", window.location.pathname);
        cart.setActiveElement?.(document.activeElement);
      }
      config.body = formData;

      try {
        const response = await fetch(`${routes.cart_add_url}`, config);
        const data = await response.json();

        if (data.status) {
          this.handleBundleError(form, data.description || data.message || "");
          return;
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        this.hasSaleItem = true;
        this.hide();

        if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "bundle-builder",
            cartData: data,
          });
        }

        cart.renderContents(data);
      } catch (error) {
        console.error(error);
      } finally {
        this.setBundleLoading(button, false);
      }
    }

    parseDiscountTiers() {
      try {
        const tiers = JSON.parse(this.dataset.discountTiers || "[]");
        return Array.isArray(tiers) ? tiers : [];
      } catch (error) {
        return [];
      }
    }

    updateSavingsCallout(selectedCount, savingsAmount) {
      const max = this.maxProducts;
      const count = max > 0 ? Math.min(selectedCount, max) : selectedCount;
      const isComplete = max > 0 && selectedCount >= max;
      const remaining = max > 0 ? Math.max(max - selectedCount, 0) : 0;
      const savingsChanged =
        this.lastSavingsAmount !== undefined && this.lastSavingsAmount !== savingsAmount;

      if (savingsChanged) {
        this.animateSavingsAmount(this.displayedSavingsAmount, savingsAmount);
      } else {
        this.setSavingsDisplay(savingsAmount);
      }

      this.lastSavingsAmount = savingsAmount;

      let statusText = "Pick your 3";
      if (isComplete) {
        statusText = "";
      } else if (selectedCount === 0) {
        statusText = "Pick your 3";
      } else if (remaining === 1) {
        statusText = "One more to go";
      } else if (remaining > 1) {
        statusText = `${remaining} more to go`;
      }

      this.savingsCalloutEyebrows.forEach((eyebrow) => {
        eyebrow.textContent = statusText;
      });

      if (this.savingsCalloutStepItems.length) {
        const stepGroups = new Map();
        this.savingsCalloutStepItems.forEach((step) => {
          const parent = step.parentElement;
          if (!stepGroups.has(parent)) stepGroups.set(parent, []);
          stepGroups.get(parent).push(step);
        });

        stepGroups.forEach((steps) => {
          steps.forEach((step, index) => {
            const isActive = index < count;
            step.classList.toggle("is-active", isActive);
            step.classList.toggle("is-complete", isComplete && isActive);
          });
        });
      }

      this.savingsCalloutStepsList.forEach((stepsEl) => {
        stepsEl.setAttribute("aria-valuemax", String(max));
        stepsEl.setAttribute("aria-valuenow", String(count));
        stepsEl.setAttribute("aria-valuetext", `${count} of ${max} items selected`);
      });
    }

    setSavingsDisplay(cents) {
      const formattedSavings = this.formatMoney(cents, this.moneyFormat);

      this.savingsCalloutMessageValues.forEach((el) => {
        el.innerHTML = formattedSavings;
      });

      this.savingsCalloutValues.forEach((el) => {
        el.innerHTML = formattedSavings;
      });

      this.displayedSavingsAmount = cents;
    }

    cancelSavingsAnimation() {
      if (this.savingsAnimationFrame) {
        cancelAnimationFrame(this.savingsAnimationFrame);
        this.savingsAnimationFrame = null;
      }
    }

    animateSavingsAmount(fromCents, toCents) {
      this.cancelSavingsAnimation();

      if (fromCents === toCents) {
        this.setSavingsDisplay(toCents);
        return;
      }

      this.pulseSavingsCalloutValue();

      const duration = 500;
      const startTime = performance.now();
      const delta = toCents - fromCents;

      const tick = (now) => {
        const progress = Math.min((now - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const currentCents = Math.round(fromCents + delta * eased);

        this.setSavingsDisplay(currentCents);

        if (progress < 1) {
          this.savingsAnimationFrame = requestAnimationFrame(tick);
        } else {
          this.savingsAnimationFrame = null;
          this.setSavingsDisplay(toCents);
        }
      };

      this.savingsAnimationFrame = requestAnimationFrame(tick);
    }

    pulseSavingsCalloutValue() {
      if (!this.savingsCalloutValues?.length) return;

      this.savingsCalloutValues.forEach((el) => {
        el.classList.remove("is-scaling");
        void el.offsetWidth;
        el.classList.add("is-scaling");
      });
    }

    bindStickySidebar() {
      if (this.stickyScrollButton && this.sidebarWrapper) {
        this.stickyScrollButton.addEventListener("click", () => {
          this.sidebarWrapper.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        });
      }

      if (!this.stickyButton) return;

      let scrollTimeout;
      this.boundScrollSidebar = () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(this.boundCheckSidebarVisibility, 10);
      };
      this.boundResizeSidebar = () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(this.boundCheckSidebarVisibility, 100);
      };

      const scrollRoot = this.bundlePopupInner || window;
      scrollRoot.addEventListener("scroll", this.boundScrollSidebar);
      window.addEventListener("resize", this.boundResizeSidebar);
      this.checkSidebarVisibility();
    }

    bindProductClicks() {
      if (!this.products) return;

      this.products.forEach((el) => {
        const dataId = el.getAttribute("data-id");
        const productPrice = Number(el.getAttribute("data-price"));
        const productComparePrice = Number(el.getAttribute("data-compare-price"));
        const limitAttr = el.getAttribute("data-limit");
        const productLimit = limitAttr !== null ? parseInt(limitAttr, 10) : null;
        const image = el.querySelector(`${this.selector("bundle-product-image")} img`);
        const imageSrc = image ? image.src : "";
        const imageAlt = image ? image.alt : "";

        const removeButton = el.querySelector(this.selector("bundle-product-check"));
        const removeWrapper = el.querySelector(this.selector("bundle-product-image-icon"));
        const handleRemove = (event) => {
          if (!this.selectedProducts[dataId]) return;
          event.preventDefault();
          event.stopPropagation();
          this.removeProduct(dataId);
        };
        if (removeButton) removeButton.addEventListener("click", handleRemove);
        if (removeWrapper) removeWrapper.addEventListener("click", handleRemove);

        el.addEventListener("click", () => {
          const currentProductCount = this.selectedProducts[dataId]?.count || 0;

          if (currentProductCount >= 1) {
            this.updateProductAddIcon(dataId);
            return;
          }

          if (productLimit !== null && currentProductCount >= productLimit) {
            this.updateProductAddIcon(dataId);
            return;
          }

          if (this.calculateTotalItems() >= this.maxProducts) return;

          this.selectedProducts[dataId] = {
            count: 1,
            price: productPrice,
            comparePrice: productComparePrice,
            imageSrc,
            imageAlt,
          };

          el.classList.add("active");
          this.updateProductAddIcon(dataId);
          this.updateSidebarProducts();
        });

        if (this.selectedProducts[dataId]) {
          el.classList.add("active");
        }

        this.updateProductAddIcon(dataId);
      });
    }

    appendHiddenInput(form, name, value, className, id) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      if (className) input.className = className;
      if (id) input.id = id;
      form.appendChild(input);
    }

    calculateTotalItems() {
      let count = 0;
      for (const productId in this.selectedProducts) {
        if (this.selectedProducts.hasOwnProperty(productId)) {
          count += this.selectedProducts[productId].count;
        }
      }
      return count;
    }

    checkSidebarVisibility() {
      if (!this.stickyButton || !this.sidebarWrapper) return;

      if (!this.hasAttribute("open")) {
        this.stickyButton.classList.remove("visible");
        return;
      }

      if (window.innerWidth >= 1024) {
        this.stickyButton.classList.remove("visible");
        return;
      }

      const viewport = this.bundlePopupInner
        ? this.bundlePopupInner.getBoundingClientRect()
        : { top: 0, bottom: window.innerHeight };
      const sidebarRect = this.sidebarWrapper.getBoundingClientRect();

      if (sidebarRect.top < viewport.bottom && sidebarRect.bottom > viewport.top) {
        this.stickyButton.classList.remove("visible");
      } else {
        this.stickyButton.classList.add("visible");
      }
    }

    getProductElement(productId) {
      return this.querySelector(`${this.selector("bundle-product")}[data-id="${productId}"]`);
    }

    removeProduct(productId) {
      if (!this.selectedProducts[productId] || this.selectedProducts[productId].count <= 0) return;

      this.selectedProducts[productId].count--;

      if (this.selectedProducts[productId].count === 0) {
        delete this.selectedProducts[productId];
        const productElement = this.getProductElement(productId);
        if (productElement) productElement.classList.remove("active");
      }

      this.updateProductAddIcon(productId);
      this.updateSidebarProducts();
    }

    calculateDiscount(count) {
      if (count <= 0) return 0;

      let targetLevel = count;

      if (count > 8) {
        if (count >= 9 && count <= 10) {
          targetLevel = 9;
        } else if (count >= 11 && count <= 12) {
          targetLevel = 11;
        } else if (count >= 13 && count <= 14) {
          targetLevel = 13;
        } else if (count >= 15) {
          targetLevel = 15;
        }
      }

      if (targetLevel > this.maxProducts) {
        targetLevel = this.maxProducts;
      }

      const discountPercent = Number(this.discountTiers[targetLevel - 1] || 0);
      return discountPercent / 100;
    }

    updateProductAddIcon(productId) {
      const productElement = this.getProductElement(productId);
      if (!productElement) return;

      const addIconWrapper = productElement.querySelector(this.selector("bundle-product-image-icon"));
      if (!addIconWrapper) return;

      const limitAttr = productElement.getAttribute("data-limit");
      const productLimit = limitAttr !== null ? parseInt(limitAttr, 10) : null;
      const currentCount = this.selectedProducts[productId]?.count || 0;
      const alreadySelected = currentCount >= 1;
      const atInventoryLimit = productLimit !== null && currentCount >= productLimit;

      if (alreadySelected) {
        addIconWrapper.style.display = "";
        productElement.classList.remove("product-disabled");
      } else if (atInventoryLimit) {
        addIconWrapper.style.display = "none";
        productElement.classList.add("product-disabled");
      } else {
        addIconWrapper.style.display = "";
        productElement.classList.remove("product-disabled");
      }
    }

    updateSidebarHeadings(totalItems, savingsAmount) {
      if (this.sidebarHeading) {
        let headingHTML = this.originalHeadingHTML;

        if (totalItems > 0) {
          const lastClosingTag = headingHTML.lastIndexOf("</");
          if (lastClosingTag !== -1) {
            headingHTML =
              headingHTML.substring(0, lastClosingTag) +
              ` (${totalItems})` +
              headingHTML.substring(lastClosingTag);
          } else {
            headingHTML += ` (${totalItems})`;
          }
        }

        this.sidebarHeading.innerHTML = headingHTML;
      }

      if (this.sidebarSubheading && savingsAmount > 0) {
        const formattedSavings = this.formatMoney(savingsAmount, this.moneyFormat);
        let subheadingHTML = this.originalSubheadingHTML;
        const lastClosingTag = subheadingHTML.lastIndexOf("</");

        if (lastClosingTag !== -1) {
          subheadingHTML =
            subheadingHTML.substring(0, lastClosingTag) +
            ` ${formattedSavings}` +
            subheadingHTML.substring(lastClosingTag);
        } else {
          subheadingHTML += ` ${formattedSavings}`;
        }

        this.sidebarSubheading.innerHTML = subheadingHTML;
      } else if (this.sidebarSubheading && savingsAmount === 0) {
        this.sidebarSubheading.innerHTML = this.originalSubheadingHTML;
      }
    }

    updateTotalAndButton() {
      let subtotal = 0;
      let totalCompare = 0;
      const totalSelectedItems = this.calculateTotalItems();

      for (const productId in this.selectedProducts) {
        if (this.selectedProducts.hasOwnProperty(productId)) {
          const productInfo = this.selectedProducts[productId];
          subtotal += productInfo.count * productInfo.price;
          totalCompare += productInfo.count * productInfo.comparePrice;
        }
      }

      const discountRate = this.calculateDiscount(totalSelectedItems);
      const total = subtotal * (1 - discountRate);
      const savingsAmount = subtotal - total;

      if (this.mainButtons?.length) {
        const isComplete = this.maxProducts > 0 && totalSelectedItems >= this.maxProducts;
        const formattedSavings = this.formatMoney(subtotal, this.moneyFormat);

        this.mainButtons.forEach((button) => {
          const label = button.querySelector(":scope > span");
          const incompleteLabel =
            button.dataset.incomplete || `Choose ${this.maxProducts} free products above`;
          const completeLabel = button.dataset.all || "Add to cart";

          button.disabled = !isComplete;
          if (label) {
            const plainSavings = formattedSavings.replace(/<[^>]*>/g, "");
            label.textContent = isComplete && subtotal > 0
              ? `${completeLabel}`
              : isComplete
                ? completeLabel
                : incompleteLabel;
          }

          if (isComplete) {
            button.removeAttribute("aria-disabled");
          } else {
            button.setAttribute("aria-disabled", "true");
          }
        });
      }

      this.updateSavingsCallout(totalSelectedItems, subtotal);

      if (this.discountLevels.length) {
        this.discountLevels.forEach((level) => {
          const levelCount = Number(level.dataset.discountLevel);
          let activeCheckLevel = totalSelectedItems;

          if (activeCheckLevel > 8) {
            if (activeCheckLevel >= 9 && activeCheckLevel <= 10) {
              activeCheckLevel = 9;
            } else if (activeCheckLevel >= 11 && activeCheckLevel <= 12) {
              activeCheckLevel = 11;
            } else if (activeCheckLevel >= 13 && activeCheckLevel <= 14) {
              activeCheckLevel = 13;
            } else if (activeCheckLevel >= 15) {
              activeCheckLevel = 15;
            }
          }

          if (activeCheckLevel >= levelCount) {
            level.classList.add("active-discount");
          } else {
            level.classList.remove("active-discount");
          }
        });
      }

      if (!this.forms?.length) return;

      this.forms.forEach((form) => {
        form.querySelectorAll('input[name^="items["]').forEach((input) => input.remove());
      });

      if (totalSelectedItems === 0) return;

      this.forms.forEach((form) => {
        let itemIndex = 0;

        for (const productId in this.selectedProducts) {
          if (!this.selectedProducts.hasOwnProperty(productId)) continue;

          const productInfo = this.selectedProducts[productId];
          if (productInfo.count <= 0) continue;

          for (let i = 0; i < productInfo.count; i++) {
            this.appendHiddenInput(form, `items[${itemIndex}][id]`, productId);
            this.appendHiddenInput(form, `items[${itemIndex}][quantity]`, "1");
            this.appendHiddenInput(form, `items[${itemIndex}][properties][_promo]`, "Black Friday Bundle");
            this.appendHiddenInput(form, `items[${itemIndex}][properties][_sale]`, "true");
            itemIndex++;
          }
        }
      });
    }

    updateSidebarProducts() {
      if (!this.bundleSidebarProductsContainer) return;

      while (this.bundleSidebarProductsContainer.firstChild) {
        this.bundleSidebarProductsContainer.removeChild(this.bundleSidebarProductsContainer.firstChild);
      }

      for (const productId in this.selectedProducts) {
        if (!this.selectedProducts.hasOwnProperty(productId)) continue;

        const productInfo = this.selectedProducts[productId];
        for (let i = 0; i < productInfo.count; i++) {
          const newDiv = document.createElement("div");
          newDiv.className = `bundle-product-block-${this.sectionId}`;
          newDiv.setAttribute("data-id", productId);

          const imageDiv = document.createElement("div");
          imageDiv.className = `bundle-sidebar-product-image-${this.sectionId}`;

          const imageElement = document.createElement("img");
          imageElement.src = productInfo.imageSrc;
          imageElement.alt = productInfo.imageAlt;

          imageDiv.appendChild(imageElement);
          newDiv.appendChild(imageDiv);
          this.bundleSidebarProductsContainer.appendChild(newDiv);

          const removeButton = document.createElement("div");
          removeButton.className = `bundle-sidebar-remove-icon-wrapper-${this.sectionId}`;
          removeButton.innerHTML = REMOVE_ICON_SVG;
          removeButton.setAttribute("data-product-id", productId);
          removeButton.addEventListener("click", (event) => {
            event.stopPropagation();
            this.removeProduct(event.currentTarget.getAttribute("data-product-id"));
          });

          newDiv.appendChild(removeButton);
        }
      }

      const emptyBlocksToAdd = this.maxProducts - this.calculateTotalItems();
      if (emptyBlocksToAdd > 0) {
        for (let i = 0; i < emptyBlocksToAdd; i++) {
          const emptyDiv = document.createElement("div");
          emptyDiv.className = `bundle-product-block-${this.sectionId} empty`;
          emptyDiv.innerHTML = EMPTY_BLOCK_SVG;
          this.bundleSidebarProductsContainer.appendChild(emptyDiv);
        }
      }

      this.updateTotalAndButton();
    }
  }

  if (!customElements.get("bundle-builder-popup")) {
    customElements.define("bundle-builder-popup", BundleBuilderPopup);
  }

  window.BundleBuilderPopup = BundleBuilderPopup;

  window.openBundleBuilderPopup = function () {
    document.querySelector("bundle-builder-popup")?.show();
  };

  window.closeBundleBuilderPopup = function () {
    document.querySelector("bundle-builder-popup")?.hide();
  };
});
